/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useEffect, useState } from "react";
import { ImageEditContext } from "cms/images/image-selector/context/image-edit-context";
import { ImageCover } from "cms/images/image-cover/image-cover";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, CircularProgress } from "@mui/material";
import { regular } from "cms/icons";
import SimpliCitySDK from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { isEmpty } from "lodash";

const { faBoxArchive } = regular;

const ImageEditArchivePanel = (props) => {
    const { token } = useAuth();
    const loading = props?.loading;
    const handleArchive = props?.handleArchive;
    const imageEditContext = useContext(ImageEditContext);
    const selectedImage = imageEditContext?.selectedImage;
    const setIsArchiving = imageEditContext?.setIsArchiving;
    const image = imageEditContext?.image;
    const setSelectedEditTab = imageEditContext?.setSelectedEditTab;
    const [imagePlacements, setImagePlacements] = useState([]);
    
    const handleCancel = () => {
        setIsArchiving(false);
    };

    const handleViewDetails = () => {
        setIsArchiving(false);
        setSelectedEditTab(1);
    };

    useEffect(() => {
        const getImagePlacements = async () => {
            const guid = image?.guid || selectedImage?.guid;
            if (guid) {
                const result = await SimpliCitySDK.images.placements(token, guid);
                setImagePlacements(result?.placements || {});
            }
        };
        getImagePlacements();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="archive-section">
            <h2 className="sectionHeader">Archive image</h2>
            <p className="archive-confirmation">Please confirm you want to archive this image:</p>
            <div className="archive-image-card">
                <ImageCover displayWidth={84} displayHeight={76} />
                <div className="archive-image-info">
                    <strong>{selectedImage?.file_name}</strong>
                    <a href={selectedImage.url} className="archive-image-link">{selectedImage?.file_name}</a>
                </div>
            </div>
            <p>
                When archiving an image:
            </p>
            <ul className="archive-details">
                <li>The image will display as a broken image on any existing webpages.</li>
                <li>The image will no longer be accessible via a public URL.</li>
                <li>The image will no longer be searchable within primary digital asset areas.</li>
                <li>The image will be stored within a secondary image archive library.</li>
            </ul>
            <div className="document-placements">
                {isEmpty(imagePlacements) ? (
                    "Currently, this image is not being used in any placements on the website and it is safe to archive it."
                ) : (
                    <div>
                    Currently, this image is being used in{" "}
                        <strong>{imagePlacements?.length} placement(s)</strong> on the website.
                    It is recommended that you manually remove or replace any existing
                    placements before proceeding.{" "}
                        <span className="doc-view-detail-cta" onClick={handleViewDetails}>
                        View details
                        </span>
                    </div>
                )}
            </div>
            <div className="simplicity-image-archive-window-footer">
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleCancel}
                    className="cancel-btn"
                >
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleArchive}
                    className="archive-btn"
                    startIcon={
                        loading ? (
                            <CircularProgress size="22px" color="inherit" />
                        ) : (
                            <FontAwesomeIcon
                                icon={faBoxArchive}
                                style={{ color: "#0E7490" }}
                            />
                        )
                    }
                    disabled={loading}
                >
                    Archive
                </Button>
            </div>
        </div>
    );
};

export { ImageEditArchivePanel };
